import { FC } from 'react';
import NumberFormat from 'react-number-format';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import { useTranslate } from 'hooks/useTranslate';

import { numberFormat } from 'constants/formats';

import UploadDocument from 'modules/documents/components/UploadDocument';
import InputTextArea from 'modules/_shared/components/InputTextArea';
import NotarySection from 'modules/_shared/components/NotarySection';
import { useConstitutionModal } from '../context/ConstitutionModalContext';

const ConstitutionModalScriptureView: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useConstitutionModal();

  const MAX_DATE = '2100-01-01';
  const MAX_COMMENT_LENGTH = 3000;

  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="operation-date">
          {t('Date')} <MandatoryField />
        </label>
        <div className="form-control-wrap">
          <input
            id="constitution-date"
            type="date"
            className="form-control form-control-lg"
            value={data.date}
            onChange={actions.handleChangeDate}
            required
            max={MAX_DATE}
            min={data.lastOperationDate}
          />
        </div>
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="total-shares">
          {t('NºNewParticipations')}
        </label>

        <MandatoryField />

        <div className="form-control-wrap">
          <div className="form-text-hint">
            <span className="overline-title">{t('Nr')}</span>
          </div>
          <NumberFormat
            id="total-shares"
            className="form-control form-control-lg"
            value={data.totalSharesToAdd}
            onChange={actions.handleChangeTotalSharesToAdd}
            thousandSeparator={numberFormat.thousandSeparator}
            decimalSeparator={numberFormat.decimalSeparator}
            allowNegative={false}
            placeholder={t('NumberOfNewParticipations')}
            decimalScale={0}
            required
          />
        </div>
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="nominal-value">
          {t('NominalValue')}
        </label>

        <MandatoryField />

        <div className="form-control-wrap">
          <div className="form-text-hint">
            <span className="overline-title">Eur</span>
          </div>
          <NumberFormat
            id="nominal-value"
            className="form-control form-control-lg"
            value={data.nominalValue}
            onChange={actions.handleChangeNominalValue}
            thousandSeparator={numberFormat.thousandSeparator}
            decimalSeparator={numberFormat.decimalSeparator}
            allowNegative={false}
            placeholder={t('NominalValueOfParticipati')}
            decimalScale={10}
            required
          />
        </div>
      </div>

      <UploadDocument
        label="AddDocumentOptional"
        inputLabel={data.file?.name || t('DragDocumentToUpload')}
        file={data.file}
        setFile={actions.handleChangeFile}
      />

      <InputTextArea
        id="constitution-comments"
        label={t('CommentsLabel')}
        value={data.comments}
        onChange={actions.handleChangeComments}
        maxLength={MAX_COMMENT_LENGTH}
        noResize
      />

      <div className="row mb-4">
        <NotarySection
          notaryName={data.notaryName}
          onChangeName={actions.handleChangeNotaryName}
          notaryProtocol={data.notaryProtocol}
          onChangeProtocol={actions.handleChangeNotaryProtocol}
          notaryCity={data.notaryCity}
          onChangeCity={actions.handleChangeNotaryCity}
          lgSize
        />
      </div>
    </>
  );
};

export default ConstitutionModalScriptureView;
